import { render } from "./MMMonthNews.vue?vue&type=template&id=74b0fd69"
import script from "./MMMonthNews.vue?vue&type=script&lang=js"
export * from "./MMMonthNews.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__